export default __webpack_public_path__ + "static/media/logo2.88ae507e.png";